export function createHeader(long) {
  const emoji = document.getElementById("emoji");
  if (emoji) {
    document.querySelectorAll(".watermarked").forEach(function (el) {
        el.dataset.watermark = (emoji.innerHTML + " ").repeat(long);
      });
  }
}
